<template>
  <section class="wrapper quiz-main">
    <div class="quiz-main-right">
      <div @click="clickglitchesEnter" class="glitchesEnter">
        <div class="glitches-text">
          <h2>Glitches</h2>
          <p>Collect questions you haven't mastered, review makes improvement.</p>
        </div>
        <div class="glitches-circle-box">
          <div class="glitches-circle">
            <canvas width="70" height="70" id="canvas-box">sorry,your browser doesn't support canvas</canvas>
          </div>
          <span class="glitches-num">{{ userQuota.quota + '/' + userQuota.quotas }}</span>
        </div>
        <ct-icon class="jiantouyou" name="jiantouyou"></ct-icon>
      </div>
      <div v-if="an.content" class="announcement">
        <h2>
          <ct-icon name="gonggao"></ct-icon>
          Announcement
        </h2>
        <div>
          <h4 v-if="an.title">{{ an.title }}</h4>
          <div v-html="an.content"></div>
        </div>
      </div>
      <quiz-board />
    </div>
    <div class="quiz-main-left">
      <div class="break-point-box" v-if="breakPoint">
        <span class="left-colorful-box">
          <ct-icon style="font-size: 16px;transform: translateY(1px);" name="pencil" :multi-color="false"></ct-icon>
          Recent trying
        </span><span class="break-point-title">
          {{ breakPoint.section }}
        </span><span class="break-point-index">
          No.{{ breakPoint.questionIndex + 1 }}
        </span><span class="break-point-id">
          ID{{ breakPoint.question_id }}
        </span>
        <span @click="goBreakPoint" class="break-point-btn">continue <ct-icon class="break-point-btn-ic"
                                                                              name="jiantouyou"
                                                                              :multi-color="false"></ct-icon> </span>
      </div>
      <div class="question-list">
        <div class="question-hide-btn-box">
          <transition name="slide">
              <span @click="hideEmpty" v-if="eyeClass==='close'" key="close" class="question-hide-btn">
                <ct-icon class="slide-item" style="font-size: 14px;" name="eye-close"></ct-icon>
                Hide empty chapters
              </span>
            <span @click="hideEmpty" v-else key="open" class="question-hide-btn">
                <ct-icon class="slide-item" style="font-size: 14px;" name="eye-open"></ct-icon>
                Show empty chapters
              </span>
          </transition>
        </div>
        <div class="question-list-detail">
          <slot v-for="item in questionList">
            <div
              :key="item.subject_type"
              v-show="item.visible"
              class="question-list-item" style="-webkit-backface-visibility: hidden;backface-visibility: hidden;">
              <div class="fisrt-point-box" @click="changeVisible(item)">
                  <span
                    :class="{'is-rotate': item.ownVisible}"
                    class="first-point-icon-question">
                    <img src="@/assets/img/comet/quiz/shi@2x.png" alt="">
                  </span>
                {{ item.text }}
                <span class="primary-badge" v-if="item.question_count[0] === 0">no questions uploaded</span>
                <span class="primary-badge" v-else>{{
                    item.question_count[1] + ' / ' + item.question_count[0]
                  }}</span>
                <!-- <span class="new-badge" v-if="item.question_count[2] !== 0">NEW {{ item.question_count[2] }}</span> -->
                <span class="bg-bottom-line"></span>
              </div>
              <el-collapse-transition>
                <div v-if="item.nodes" v-show="item.ownVisible">
                  <div
                    v-for="(node, index) in item.nodes"
                    :key="node.id">
                    <quiz-item
                      :ownVisible="node.ownVisible"
                      :item="node"
                      :visChangeDown="visChangeDown"
                      @clickSecond="clickSecond"
                      @changeVis="changeVis"
                      :class="{ 'no-border': index === questionList.length - 1 }" />
                  </div>
                </div>
              </el-collapse-transition>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <ct-modal
      v-if="goQuizModal"
      width="480px"
      title=""
      @closed="closeGoGuiz">
      <div slot="body" class="go-quiz-body">
        Please log in to get access of XXX. If you don't have an account, please sign up with your email.
      </div>
      <div style="overflow: hidden;" slot="footer">
        <ct-button @click="goRegist" class="go-quiz-btn" size="small" type="primary">Sign up</ct-button>
        <ct-button @click="goLogin" class="go-quiz-btn" size="small" type="secondary">Log in</ct-button>
        <ct-button @click="closeGoGuiz" class="go-quiz-btn" size="small" type="text_secondary_light">Cancel</ct-button>
      </div>
    </ct-modal>
  </section>
</template>

<script>
import QuizItem from './QuizItem'
import QuizBoard from './QuizBoard'
import drawCircle from '@/utils/circle.js'
import { mapGetters, mapActions } from 'vuex'
import cookie from '@/utils/cookie'
import { vueAppPassportDomin, vueAppDomin } from '@ca/constants/variables.js'
import api from '../../api'

export default {
  name: 'Quiz',
  components: {
    'quiz-item': QuizItem,
    'quiz-board': QuizBoard
  },
  data () {
    return {
      questionList: [],
      hideDown: true,
      eyeClass: 'close',
      goQuizModal: false,
      vueAppPassportDomin,
      userQuota: {
        quota: 0,
        quotas: 50
      },
      hasGetQuota: false,
      an: {
        title: '',
        content: ''
      },
      currentActive: -1,
      visChangeDown: true
    }
  },
  methods: {
    ...mapActions(['getSkillTree']),
    goBreakPoint () {
      this.$router.push({
        path: `quizs/${this.breakPoint.chapter}/${this.breakPoint.section}/${this.breakPoint.sectionId}?index=${this.breakPoint.questionIndex}`
      })
    },
    changeVisible (item) {
      if (!this.visChangeDown) return
      if (!item.nodes || !item.nodes.length) return
      this.visChangeDown = false
      let id = this.currentActive === item.id ? -1 : item.id
      this.currentActive = id
      const a = JSON.parse(JSON.stringify(this.questionList))
      a.forEach(el => {
        el.ownVisible = el.id === id
        if (el.id === id && el.nodes) {
          el.nodes.forEach(node => {
            node.visible = true
            node.ownVisible = false
          })
        }
      })
      this.questionList = a
      setTimeout(() => {
        this.visChangeDown = true
      }, 200)
    },
    changeVis (item) {
      this.visChangeDown = false
      const a = JSON.parse(JSON.stringify(this.questionList))
      let id = this.currentActive === item.id ? -1 : item.id
      a.forEach(el => {
        if (el.nodes) {
          el.nodes.forEach(ell => {
            ell.ownVisible = ell.id === id
            if (ell.nodes) {
              ell.nodes.forEach(node => {
                node.visible = true
                node.ownVisible = false
              })
            }
          })
        }
      })
      this.questionList = a
      setTimeout(() => {
        this.visChangeDown = true
      }, 200)
    },
    clickSecond (point) {
      // if (!point.question_count || !point.question_count[0]) return
      if (!this.isAuthenticated) {
        this.goQuizModal = true
        return
      }
      let first = {}
      this.skillTree.find(el => {
        if (el.nodes) {
          el.nodes.forEach(node => {
            if (node.id === point.parent_id) {
              first = node
            }
          })
        }
      })
      if (!first) {
        this.$toast({
          type: 'warning',
          message: 'oops, something went wrong, please try again later'
        })
      }
      this.$router.push({
        path: `quizs/${first.text}/${point.text}/${point.id}`
      })
    },
    closeGoGuiz () {
      this.goQuizModal = false
    },
    fomatData (arr) {
      const a = JSON.parse(JSON.stringify(arr))
      a.forEach(el => {
        el.visible = true
        el.ownVisible = false
      })
      return a
    },
    clickglitchesEnter () {
      this.$router.push({
        name: 'issueList'
      })
    },
    hideEmpty () {
      if (!this.hideDown) return
      this.hideDown = false
      const a = JSON.parse(JSON.stringify(this.questionList))
      a.forEach(el => {
        if (el.question_count[0] === 0) {
          el.visible = !el.visible
        }
        if (el.nodes) {
          el.nodes.forEach(ell => {
            if (ell.question_count[0] === 0) {
              ell.visible = !ell.visible
            }
          })
        }
      })
      this.questionList = a
      this.eyeClass = this.eyeClass === 'close' ? 'open' : 'close'
      setTimeout(() => {
        this.hideDown = true
      }, 300)
    },
    goLogin () {
      window.location.href = vueAppPassportDomin + 'Login?return_url=' + vueAppDomin + '/courses'
    },
    goRegist () {
      window.location.href = vueAppPassportDomin + 'Register?return_url=' + vueAppDomin + '/courses'
    },
    getQuota () {
      if (this.hasGetQuota) return
      this.hasGetQuota = false
      api.getWrongQuota().then(res => {
        this.hasGetQuota = true
        let data = res.data
        if (data.code === 1) {
          this.userQuota = {
            quota: data.data.num,
            quotas: data.data.total_num
          }
        }
      }, err => {
        this.hasGetQuota = true
        this.userQuota = {
          quota: 0,
          quotas: 50
        }
        console.log(err)
      })
    }
  },
  mounted () {
    this.$store.dispatch('getSkillTree').then(res => {
      this.questionList = this.fomatData(this.skillTree)
    })
    if (this.isAuthenticated) {
      this.getQuota()
    }
    api.getAnnouncement().then(res => {
      let data = res.data
      if (data.code === 1) {
        data = data.data
        this.an.title = data.title || ''
        this.an.content = data.content || 'no annoucement'
      }
    })
  },
  watch: {
    userQuota (newVal, oldVal) {
      const a = newVal.quota
      const b = newVal.quotas
      const c = document.getElementById('canvas-box')
      const ctx = c.getContext('2d')
      ctx.clearRect(0, 0, 70, 70)
      drawCircle(ctx, a, b, 35, 35, 4, 29, '#1A3D5E', 400)
    },
    isAuthenticated (val) {
      if (val) {
        this.getQuota()
      }
    }
  },
  computed: {
    ...mapGetters(['profile', 'isAuthenticated', 'isAdminRole', 'skillTree']),
    breakPoint () {
      return (this.isAuthenticated && cookie.getCookie('quiz_breakpoint')) ? JSON.parse(unescape(cookie.getCookie('quiz_breakpoint'))) : null
    }
  }
}
</script>

<style lang="scss" scoped>
.quiz-main {
  margin-top: 16px;
  margin-bottom: 30px;

  .quiz-main-left {
    width: 816px;

    .break-point-box {
      height: 28px;
      box-shadow: 0px 2px 12px 0px rgba(35, 62, 114, 0.07);
      border-radius: 14px;
      line-height: 28px;
      margin-bottom: 8px;
      color: rgba(26, 61, 94, 1);
      font-size: 14px;

      .left-colorful-box {
        display: inline-block;
        overflow: hidden;
        background: rgba(247, 251, 255, 1);
        border-radius: 20px 0px 0px 20px;
        width: 132px;
        text-align: center;
        font-weight: 500;
      }

      .break-point-title {
        display: inline-block;
        overflow: hidden;
        margin-left: 16px;
        margin-right: 4px;
        max-width: 40%;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .break-point-index,
      .break-point-id {
        display: inline-block;
        overflow: hidden;
        color: rgba(163, 177, 191, 1);
        margin-left: 12px;
      }

      .break-point-btn {
        float: right;
        margin-right: 40px;
        color: #37CAD7;
        cursor: pointer;

        .break-point-btn-ic {
          transition: all .2s;
          transform: translateX(0px);
        }

        &:hover {
          .break-point-btn-ic {
            transform: translateX(4px);
          }
        }
      }
    }

    .question-list {
      box-shadow: 0px 2px 14px 0px rgba(79, 117, 162, 0.07);
      border-radius: 2px;
      padding: 25px 24px 32px;

      .question-hide-btn-box {
        height: 18px;
        line-height: 18px;
        margin-bottom: 10px;
        font-size: 13px;
        color: #1A3D5E;
        position: relative;
        overflow-x: hidden;

        .question-hide-btn {
          float: right;
          cursor: pointer;

          &:hover {
            color: #37CAD7;
          }
        }

        .slide-leave-active, .slide-enter-active {
          transition: all .5s ease;
          position: absolute;
          right: 0;
        }

        .slide-enter
          /* .slide-fade-leave-active for below version 2.1.8 */
        {
          transform: translateX(100px);
          opacity: 0;
        }

        .slide-leave-to {
          transform: translateX(-100px);
          opacity: 0;
        }
      }
    }
  }

  .quiz-main-right {
    width: 316px;
    float: right;

    .glitchesEnter {
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
      align-items: center;
      height: 105px;
      background: linear-gradient(135deg, rgba(21, 197, 213, 1) 0%, rgba(55, 202, 215, 1) 100%);
      box-shadow: 0px 2px 5px 0px rgba(208, 209, 209, 0.37);
      border-radius: 2px;
      font-size: 12px;
      cursor: pointer;
      color: #1A3D5E;
      margin-bottom: 8px;

      .glitches-text {
        h2 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 8px;
        }
      }

      .glitches-circle-box {
        position: relative;
        margin-right: 16px;

        .glitches-circle {
          border-radius: 50%;
          width: 60px;
          height: 60px;
          border: 3px solid rgba(26, 61, 94, .16);

          #canvas-box {
            position: relative;
            left: -8px;
            top: -8px;
            z-index: 1;
          }
        }

        .glitches-num {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          white-space: nowrap;
        }
      }

      .jiantouyou {
        transform: translateX(0px) rotate(0deg);
        transition: all .5s;
      }

      &:hover {
        .jiantouyou {
          transform: translateX(4px) rotate(360deg);
        }
      }
    }

    .announcement {
      box-shadow: 0px 2px 5px 0px rgba(210, 225, 238, 0.37);
      border-radius: 20px 0 0 0;
      font-family: SFProDisplay-Medium;
      color: rgba(26, 61, 94, 1);
      margin-bottom: 8px;

      > h2 {
        line-height: 30px;
        background: rgba(239, 244, 250, 1);
        border-radius: 20px 0px 0px 20px;
        font-size: 16px;
        font-weight: 500;
        padding: 0 16px;
      }

      > div {
        padding: 16px 16px 24px;
        word-wrap: break-word;

        > h4 {
          font-size: 14px;
          font-weight: 500;
          line-height: 14px;
          margin-bottom: 8px;
        }

        > div {
          font-size: 14px;
          font-weight: 400;
          color: rgba(54, 85, 114, 1);
          line-height: 22px;
        }
      }

    }

    .rank {
      box-shadow: 0px 2px 12px 0px rgba(35, 62, 114, 0.07);
      border-radius: 2px;
    }
  }

  .go-quiz-body {
    font-size: 20px;
    font-weight: 500;
    color: rgba(54, 85, 114, 1);
    line-height: 28px;
  }

  .go-quiz-btn {
    float: right;
    margin-left: 16px;
  }
}

@media screen and (max-width: 1200px) {
  .quiz-main {
    .quiz-main-left {
      width: 580px;

      .break-point-box {
        .break-point-title {
          max-width: 30%;
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .quiz-main {
    .quiz-main-left {
      width: calc(100% - 40px);
      margin: 0 20px;
    }

    .quiz-main-right {
      float: none;
      width: calc(100% - 40px);
      margin: 0 20px;
    }
  }
}

@media screen and (max-width: 600px) {
  .quiz-main {
    .quiz-main-left {
      .break-point-box {
        .break-point-title {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .quiz-main {
    .quiz-main-left {
      .break-point-box {
        display: none;
      }
    }
  }
}

</style>
